export default "__VITE_ASSET__DhO36$yv__"